/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ActiveCustomer
 */
export interface ActiveCustomer {
    /**
     * 
     * @type {number}
     * @memberof ActiveCustomer
     */
    customerId?: number;
}

/**
 * Check if a given object implements the ActiveCustomer interface.
 */
export function instanceOfActiveCustomer(value: object): boolean {
    return true;
}

export function ActiveCustomerFromJSON(json: any): ActiveCustomer {
    return ActiveCustomerFromJSONTyped(json, false);
}

export function ActiveCustomerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveCustomer {
    if (json == null) {
        return json;
    }
    return {
        
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
    };
}

export function ActiveCustomerToJSON(value?: ActiveCustomer | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'customerId': value['customerId'],
    };
}

